/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import config from "../config/sidebarItems.config.json";
import { DEFAULT_APP_CONFIG as platformConfig } from "../../../config/default.config";

const SERVICE_NAME = "AppNavigatorService.SidebarItemsService";
const log: any = LoggerModule.getInstance();

interface ISidebarProps {
  whoami: string;
}

export interface ISidebarMethods extends IPluginMethodMap {
  getSidebarItems(args: ISidebarProps): Promise<any>;
}

export class SidebarItemService implements IAgentPlugin {
  readonly methods: ISidebarMethods;

  constructor() {
    this.methods = {
      getSidebarItems: this.getSidebarItems.bind(this),
    };
  }

  async getSidebarItems(args: ISidebarProps) {
    const { whoami } = args;
    const items = config.sidebarItems;
    const _items: any = [];
    for (let i = 0; i < items?.length; ++i) {
      const _item: any = items[i];
      // @ts-ignore
      if (
        platformConfig?.platformSemantics[_item.id] &&
        platformConfig?.platformSemantics[_item.id].title
      ) {
        // @ts-ignore
        _item.title = platformConfig?.platformSemantics[_item.id].title;
      }
      // @ts-ignore
      if (
        platformConfig?.platformSemantics[_item.id] &&
        platformConfig?.platformSemantics[_item.id].icon
      ) {
        // @ts-ignore
        _item.icon = platformConfig?.platformSemantics[_item.id].icon;
      }
      if (_item?.id) {
        if (!this.isBlackListFound(whoami, _item?.id)) {
          _items.push(_item);
        }
      } else if (_item?.children) {
        const _children: any = [];
        _item?.children.forEach((_childItem: any) => {
          // @ts-ignore
          if (
            platformConfig?.platformSemantics[_childItem.id] &&
            platformConfig?.platformSemantics[_childItem.id].title
          ) {
            // @ts-ignore
            _childItem.title =
              platformConfig?.platformSemantics[_childItem.id].title;
          }
          // @ts-ignore
          if (
            platformConfig?.platformSemantics[_childItem.id] &&
            platformConfig?.platformSemantics[_childItem.id].icon
          ) {
            _childItem.icon =
              // @ts-ignore
              platformConfig?.platformSemantics[_childItem.id]?.icon;
          }
          if (_childItem?.id) {
            if (!this.isBlackListFound(whoami, _childItem?.id)) {
              _children.push(_childItem);
            }
          }
        });
        const _temp = { ..._item };
        _temp.children = _children;
        _items.push(_temp);
      } else {
        _items.push(_item);
      }
    }
    return { sidebarItems: _items };
  }

  private isBlackListFound(whoami: string, id: string) {
    let _found = false;
    // @ts-ignore
    const blacklist = config["blacklistItems"][whoami];
    if (blacklist) {
      if (blacklist.find((bl: any) => bl == id)) {
        _found = true;
      }
    }
    return _found;
  }
}
